<template>
  <!-- SIGN UP MODAL -->
  <b-modal
    @hide="onHandleCloseModal('signUpModal')"
    v-model="onChangeSignUpModal"
    :id="getModals.cityModalModalId"
    :ref="getModals.cityModalModalId"
    title="Register With Miraj"
    class="imp-popup"
    hide-footer
  >
    <div>
      <div class="p-3">
        <div
          class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto px-2"
        >
          <div class="row">
            <!-- <div class="col-6 my-3">
              <router-link to @click.native="facebookLogin()">
                <img
                  class="img-fluid"
                  alt="Facebook Login"
                  src="@/assets/img/icons/facebook-login.svg"
                />
              </router-link>
            </div>
            <div class="col-6 my-3">
              <router-link to @click.native="googleLogin()">
                <img
                  class="img-fluid"
                  alt="Google Login"
                  src="@/assets/img/icons/google-login.svg"
                />
              </router-link>
            </div> -->

            <div class="col-12 my-3 px-3 text-center">
              Hey User, please verify your details below in order to create an
              account.
            </div>

            <!-- <div class="col-12 text-center mt-2 mb-4">
              <div class="or-text">&bull;&nbsp;OR&nbsp;&bull;</div>
            </div> -->

            <!-- ************ -->
            <form @submit.stop.prevent="onSubmitUserSignUp">
              <div class="form-row">
                <div class="col-12 mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="validationCustom01"
                    placeholder="Enter Full Name"
                    :value="getSignupFormValues.userName"
                    @input="
                      onHandleSignUpFormValues({
                        event: $event,
                        name: 'userName',
                        value: $event.target.value,
                      })
                    "
                  />
                  <div class="small text-danger">
                    {{ getSignupFormError.userName }}
                  </div>
                </div>

                <!-- VUE-TEL-INPUT -->
                <!-- <div class="col-12 mb-3">
                  <vue-tel-input v-model="phone" class="pl-0 form-control"></vue-tel-input>
                  <div class="small text-danger">Test Message</div>
                </div>-->

                <!-- HIDE IF USE TEL-INPUT -->
                <div class="col-12 mb-3">
                  <div class="form-row">
                    <!-- <div class="col-3">
                      <div class="has-chevron" :class="countryCode ? 'chevron-inverse' : ''">
                        <input
                          type="search"
                          placeholder="+ 91"
                          v-model="searchCountry"
                          v-on:blur="countryCode = !countryCode"
                          v-on:focus="countryCode = !countryCode"
                          class="form-control"
                        />
                      </div>
                      <div class="select-location-box countryCode" v-if="countryCode">
                        <ul class="search-result-list">
                          <li
                            v-for="(countryCode, countryCodeIndex) in 10"
                            :key="countryCodeIndex"
                          >+ 91</li>
                        </ul>
                      </div>
                    </div>-->
                    <div class="col-12">
                     <input
                        type="number"
                        maxlength="10"
                        onkeyup="this.value=this.value.replace(/[^0-9]+/g,'');"
                        onkeypress="if(this.value.length==10) return false;"
                        class="form-control"
                        id="validationCustom02"
                        placeholder="Enter whatsapp number"
                        :value="getSignupFormValues.userNumber"
                        @input="
                          onHandleSignUpFormValues({
                            event: $event,
                            name: 'userNumber',
                            value: $event.target.value,
                          })
                        "
                      />
                    </div>
                  </div>
                  <div
                    v-if="getSignupFormError.userNumber"
                    class="small text-danger"
                  >
                    {{ getSignupFormError.userNumber }}
                  </div>
                </div>
                <!-- ********** -->
                <div class="col-12 mb-3">
                  <input
                    type="email"
                    class="form-control"
                    id="validationCustomUsername"
                    placeholder="Enter Email ID (optional)"
                    :value="getSignupFormValues.userEmail"
                    @input="
                      onHandleSignUpFormValues({
                        event: $event,
                        name: 'userEmail',
                        value: $event.target.value,
                      })
                    "
                  />
                  <!-- <div
                    v-if="getSignupFormError.userEmail"
                    class="small text-danger"
                  >{{ getSignupFormError.userEmail }}</div>-->
                </div>
              </div>
              <div class="col-12 mb-3">
                <b-form-checkbox
                  v-model="OnHandleTerms"
                  class="small"
                  value="Y"
                  unchecked-value="N"
                >
                  <div class="pt-1">
                    <span>I agree to all</span>
                    <router-link
                     class="text-rose-gold"
                      to
                      @click.native="
                        onHandleCloseModal('signUpModal');
                        $router.push({ name: 'Terms and Conditions' });
                      "
                      title="Terms &amp; Conditions"
                      >Terms &amp; Condition</router-link
                    >&nbsp;and
                    <router-link
                    class="text-rose-gold"
                      to
                      @click.native="
                        onHandleCloseModal('signUpModal');
                        $router.push({ name: 'Privacy Policy' });
                      "
                      title="Privacy Policy"
                      >Privacy Policy</router-link
                    >
                  </div>
                </b-form-checkbox>
                <div
                  v-if="getSignupFormError.userTerms"
                  class="small text-danger"
                >
                  {{ getSignupFormError.userTerms }}
                </div>
              </div>
              <button class="btn btn-primary w-100" type="submit">
                CREATE ACCOUNT
              </button>
            </form>
            <!-- ************ -->
            <div class="col-12 text-center my-3">
              <span class="text-muted">Already a user?</span>
              <router-link
                to
                class="text-rose-gold"
                @click.native="onHandleOpenModal('signInModal')"
                >Sign In</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { initFbsdk } from "@/config/facebook_oAuth.js";
export default {
  data() {
    return {
      showModal: true,
      countryCode: false,
      searchCountry: "",
    };
  },
  mounted() {
    initFbsdk();
  },
  computed: {
    onChangeSignUpModal: {
      get() {
        return this.getModals.signUpModal;
      },
      set(value) {
        !value ? this.onHandleCloseModal("signUpModal") : undefined;
      },
    },
    OnHandleTerms: {
      get() {
        return this.getSignupFormValues.userTerms;
      },
      set(value) {
        this.onHandleSignUpFormValues({
          event: null,
          name: "userTerms",
          value: value,
        });
      },
    },
    ...mapGetters([
      // Modal
      "getModals",
      "getSignupFormValues",
      // ERROR
      "getSignupFormError",
    ]),
  },
  methods: {
    ...mapActions([
      "onHandleSignUpFormValues",
      "onHandleCloseModal",
      "onSubmitUserSignUp",
      "onHandleOpenModal",
    ]),

    async googleLogin() {
      this.$gAuth
        .signIn()
        .then((GoogleUser) => {
          // on success do something
          const googleLoggedinUser = GoogleUser.getBasicProfile();
          this.onHandleSignUpFormValues({
            event: null,
            name: "userName",
            value: googleLoggedinUser.Ad,
          });
          this.onHandleSignUpFormValues({
            event: null,
            name: "userEmail",
            value: googleLoggedinUser.Wt,
          });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    async facebookLogin() {
      window.FB.login((response) => {
        window.FB.api("/me", (response) => {
          this.onHandleSignUpFormValues({
            event: null,
            name: "userName",
            value: response.name,
          });
        });
      }, this.params);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modals/signup.vue